import { TripOverviewSection } from './types'

/** Member-mode route segment per section. Note `money` → `balances`. */
const SECTION_SEGMENTS: Record<TripOverviewSection, string> = {
	itinerary: 'itinerary',
	ideas: 'ideas',
	accommodations: 'accommodations',
	flights: 'flights',
	files: 'files',
	money: 'balances',
}

/** The member-mode app route for a bento section of the given trip. */
export const sectionPath = (tripId: string, section: TripOverviewSection): string =>
	`/trips/${tripId}/${SECTION_SEGMENTS[section]}`
